import { render, staticRenderFns } from "./carCostDetail.vue?vue&type=template&id=25a10b82&scoped=true&"
import script from "./carCostDetail.vue?vue&type=script&lang=js&"
export * from "./carCostDetail.vue?vue&type=script&lang=js&"
import style0 from "./carCostDetail.vue?vue&type=style&index=0&id=25a10b82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a10b82",
  null
  
)

export default component.exports